// src/components/terms/TermsHero.jsx
const TermsHero = () => {
  // Your background image URL
  const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1766838518/business-handshake-contract_zlshfk.jpg";

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundPosition: "50% 50%",
        }}
      >
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="container-custom relative z-10">
        <div className="text-center text-white 2xl:space-y-8">
          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
            Terms <span className="font-bold text-[#c9a86c]">& Conditions</span>
          </h1>

          {/* Description */}
          <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
            By accessing or using our services, you agree to be bound by these terms. This agreement outlines the rules, guidelines, and legal framework governing your relationship with our platform.
          </p>

          {/* Last Updated */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20 animate-fade-in-up animation-delay-800">
            <span className="text-sm text-gray-300">Effective Date:</span>
            <span className="text-sm font-semibold text-[#c9a86c]">March 15, 2026</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsHero;